import { Routes } from '@angular/router'
import { HomeComponent } from './home/home.component';
import { UserComponent } from './user/user.component';
import { ProfileComponent } from './user/profile/profile.component';
import { RegisterComponent } from './user/register/register.component';
import { TestReportListComponent } from './reporting/testreportlist/testreportlist.component';
import { AuthGuard } from './auth/auth.guard';
import { MyPatientsComponent } from './reporting/mypatients/mypatients.component';
import { PatientSearchComponent } from './reporting/patientsearch/patientsearch.component';
import { OrderSearchComponent } from './reporting/ordersearch/ordersearch.component';
import { OrderTrackingComponent } from './shipping/ordertracking/ordertracking.component';
import { TestSummaryComponent } from './reporting/testsummary/testsummary.component';
import { DelegationComponent } from './delegation/delegation.component';
import { ChangePasswordComponent } from './user/changepassword/changepassword.component';
import { ForgotPasswordComponent } from './user/forgotpassword/forgotpassword.component';

export const appRoutes: Routes = [
    { path: 'home', component: HomeComponent, canActivate:[AuthGuard] },
    { path: 'user/delegation', component: DelegationComponent, canActivate:[AuthGuard] },
    { path: 'reporting/testreportlist', component: TestReportListComponent, canActivate:[AuthGuard]},
    { path: 'reporting/patientsearch', component: PatientSearchComponent, canActivate:[AuthGuard]},
    { path: 'reporting/mypatients', component: MyPatientsComponent, canActivate:[AuthGuard]},
    { path: 'reporting/ordersearch', component: OrderSearchComponent, canActivate:[AuthGuard]},
    { path: 'reporting/testsummary', component: TestSummaryComponent, canActivate:[AuthGuard]},
    { path: 'shipping/ordertracking', component: OrderTrackingComponent, canActivate:[AuthGuard]},
    {
        path: 'register', component: UserComponent,
        children: [{ path: '', component: RegisterComponent }]
    },
    {
        path: 'login', pathMatch: 'full', component: UserComponent,
        children: [{ path: '', component: HomeComponent }]
    },
    {
        path: 'user', component: UserComponent, canActivate:[AuthGuard],
        children: [
            {path: 'profile', component: ProfileComponent},
            {path: 'changepassword', component: ChangePasswordComponent}
        ]
    },
    { path: 'user/forgotpassword', component: ForgotPasswordComponent, pathMatch: 'full'},
    { path: '**', redirectTo:'/home' },
    { path : '', redirectTo:'/home', pathMatch : 'full' }
];